export default {
    title: "itthon",
    button: {
        accessories: "Böngésszen a katalógusban"
    },
    noAvailableItems: "A Periféria Portálon jelenleg egyetlen elem sem érhető el az Ön országában. Kérjük, működjön együtt menedzserével a szükséges cikkek beszerzésében.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Lépjen kapcsolatba az ügyfélszolgálattal</a>",
    error: "Hiba történt a termékek lekérésekor. Kérem frissítse a böngészőjét."
}